import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SuccessMessage from './../../components/successMessage';
import FailedMessage from './../../components/FailedMessage';
import useApiUrls from "../../useApiUrls";

const AddApiKeyOperation = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { getUrlByOperation } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    allowip: "",
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setErrorMessage("");

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId");
      setErrorMessage("Authentication token missing.");
      return;
    }

    try {
      const SubUserApiKeyOperationInsert = getUrlByOperation("SubUserApiKeyOperationInsert");   
      const response = await axios.post(
        SubUserApiKeyOperationInsert,
        {
          allowip: formData.allowip
        },
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      console.log("Insert API Response:", response.data);

      if (response.data && (response.data.isresponse === false || response.data.responsestatus === "FAIL")) {
        setErrorMessage(response.data.errormsg || "Failed to add API Key Operation.");
        setMessage("");
      } else {
        setMessage("API Key Operation added successfully!");
        setErrorMessage("");
        setTimeout(() => {
          navigate("/api-key-operation-list");
        }, 2000);
      }
    } catch (error) {
      console.error("Insert error:", error);
      setErrorMessage(error.response?.data?.errormsg || "Failed to add API Key Operation.");
      setMessage("");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add API Key Operation</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Allowed IP Address</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.allowip}
                                onChange={handleChange}
                                placeholder="Enter IP Address..."
                                name="allowip"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && <SuccessMessage message={message} />}
      {errorMessage && <FailedMessage message={errorMessage} />}
    </>
  );
};

export default AddApiKeyOperation;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
